import moment, { Moment } from "moment";

export type Schedule = {
  startAt: Moment;
  endAt: Moment;
  title: string;
  // 省略時は defaultMessage を表示する。改行(\n)はそのまま改行として表示される
  message?: string;
}

export const defaultMessage = `データメンテナンスを実施しております。
誠に申し訳ございませんが、メンテナンス中はサービスのご利用を停止させていただいております。
受講者様には大変ご迷惑をお掛けし大変申し訳ございません。
今しばらくお待ちいただけますようお願い申し上げます。`;

export const schedules: Array<Schedule> = [
  {
    startAt: moment('2026-10-25T00:00:00+0900'),
    endAt: moment('2026-10-25T00:01:00+0900'),
    title: '期限以前ですが確認のため再開します',
},
];

export const getCurrentSchedule = (now: Moment, schedules: Array<Schedule>): Schedule | undefined => {
  return schedules.find(x => x.endAt > now && now >= x.startAt)
}
